import React from 'react';

import styles from './styles.module.css';

/**
 * @param {{ name: string, number?: string, prefix?: string }} props
 */
const CrewMemberCredentials = ({ name, number, prefix = 'Employee number: ' }) => {
	return (
		<div className={styles.drivercred}>
			<div>{name}</div>
			<div className={styles.fine}>
				{prefix}
				{number ? number : 'N/A'}
			</div>
		</div>
	);
};

export default CrewMemberCredentials;
